import type { ContactSidebarProps } from './ContactSidebar.types';
import { ContactSidebarHeader } from './Subcomponents/Header';
import { ContactSidebarMain } from './Subcomponents/Main';
import { ContactSidebarContext } from './ContactSidebarContext';
import { ContactSidebarInvitation } from './Subcomponents/Main/Invitation';
import { useGeographies } from 'hooks/redux/useGeographies';

export const ContactSidebar = (props: ContactSidebarProps) => {
  const { userProfile, jobApplications = [], userProfileMetadata } = props;
  const { geographyOptions } = useGeographies();

  if (!userProfile) {
    return null;
  }

  const [lastJobApplication, ...otherJobApplications] = jobApplications;

  return (
    <ContactSidebarContext.Provider
      value={{
        userProfile,
        lastJobApplication,
        otherJobApplications,
        userProfileMetadata,
        hasPreferences: {
          expectedCompensation: Boolean(
            (userProfile.expectedCompensation?.().min ||
              userProfile.expectedCompensation?.().max) &&
              userProfile.expectedCompensation?.().interval,
          ),
          ageGroups: Boolean(userProfile.ageGroups?.()?.length),
          desiredJobs: Boolean(userProfile.desiredJobs?.()?.length),
          desiredLocations: Boolean(userProfile.desiredLocations?.(geographyOptions)?.length),
          desiredRoles: Boolean(userProfile.desiredRoles?.()?.length),
          startDate: Boolean(userProfile.startDate?.()),
          schedule:
            Boolean(userProfile.schedule?.()) &&
            Boolean(Object.keys(userProfile.schedule?.()).length),
        },
      }}
    >
      <div className="flex flex-col h-full">
        <div className="flex-none">
          <ContactSidebarHeader />
        </div>

        <div className="flex flex-col flex-1 -mx-3 px-3 overflow-auto">
          <ContactSidebarMain />
          <div className="sticky bottom-0">
            <div className="h-8 bg-gradient-to-t from-neutral-full-white to-transparent" />

            <ContactSidebarInvitation />
          </div>
        </div>
      </div>
    </ContactSidebarContext.Provider>
  );
};

ContactSidebar.displayName = 'ContactSidebar';
